import { Immutable } from "immer";
import React from "react";

import { _RichNavigation__CalloutLink as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { IntrinsicElementProps } from "@thelabnyc/thelabui/src/utils/types";

import styles from "./index.module.scss";

type Props = Immutable<{
    value: Value;
}> & {
    attrs?: IntrinsicElementProps<HTMLElement>;
};

export const RichNavigationCalloutLink = (
    props: Props,
): React.JSX.Element | null => {
    const isActive =
        !props.value.promo_period || props.value.promo_period.is_promo_active;
    if (!isActive) {
        return null;
    }
    const href = props.value.link?.url;
    const ctaLabel = props.value.link?.title;

    return (
        <div className={`${styles.calloutLink} rich-navigation--callout-link`}>
            {props.value.text && (
                <RichTextBlock
                    className={styles.calloutContent}
                    value={props.value.text}
                />
            )}
            {href && ctaLabel && (
                <a href={href} className={styles.calloutCta}>
                    {ctaLabel}
                </a>
            )}
        </div>
    );
};
